import React from "react";
import { TabView, TabPanel } from "primereact/tabview";

export const IdwalTab = () => {
    return (
        <div className="max-width-wrapper">
            <TabView>
                <TabPanel key="This is Tab 1" header="This is Tab 1"></TabPanel>
                <TabPanel key="This is Tab 2" header="This is Tab 2"></TabPanel>
                <TabPanel key="This is Tab 3" header="This is Tab 3"></TabPanel>
                <TabPanel key="This is Tab 4" header="This is Tab 4"></TabPanel>
                <TabPanel key="This is Tab 5" header="This is Tab 5"></TabPanel>
                <TabPanel key="This is Tab 6" header="This is Tab 6"></TabPanel>
            </TabView>
        </div>
    );
};
